"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

var _Box = _interopRequireDefault(require("../Box/Box"));

var _Illustration = _interopRequireDefault(require("../Illustration/Illustration"));

var _Button = _interopRequireDefault(require("../Button/Button"));

require("./Login.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
Login component
*/
function Login(_ref) {
  var name = _ref.name,
      illustration = _ref.illustration,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["name", "illustration"]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "st_login"
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    padding: {
      all: 'mlg'
    },
    className: "st_login__box"
  }, illustration && /*#__PURE__*/_react["default"].createElement(_Illustration["default"], {
    className: "st_login__illustration",
    name: illustration
  }), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "st_login__name"
  }, name), /*#__PURE__*/_react["default"].createElement("p", {
    className: "st_login__text"
  }, "Please click login to continue"), /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    primary: true,
    fullWidth: true
  }, otherProps), "Login")));
}

Login.propTypes = {
  /** dom element for the BUTTON */
  componentEl: utils.componentEl.props,

  /** name of app */
  name: _propTypes["default"].string.isRequired,

  /** name of illustraton to show */
  illustration: _propTypes["default"].string,

  /** click handler for the BUTTON */
  onClick: _propTypes["default"].func.isRequired
};
Login.defaultProps = {
  componentEl: utils.componentEl.defaults,
  illustration: null
};
var _default = Login;
exports["default"] = _default;